import { render, staticRenderFns } from "./resourceTrends.vue?vue&type=template&id=7f4cb81a&"
import script from "./resourceTrends.vue?vue&type=script&lang=js&"
export * from "./resourceTrends.vue?vue&type=script&lang=js&"
import style0 from "./resourceTrends.vue?vue&type=style&index=0&id=7f4cb81a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports